
<script>
  export let formatter;
  export let data;

  /* Daily & Highlighted opening hours */
  $: unformatted = data.dailyOpeningHours || data.days ?
    [data] : data.unformattedOpeningHours;

  let formattedHours = [];

  $: if (unformatted) {
    formattedHours = unformatted.map(x => {

      const { days, openingStatus, dailyOpeningHours = [] } = x;

      const hours = dailyOpeningHours
        .map(formatter.formatDailyHours.bind(formatter));

      return {
        days: formatter.daysRange(days),
        openingStatus,
        isOpen: openingStatus == 'OPEN',
        hours,
        statusText: formatter.statusText(openingStatus)
      };
    });
  }

  /* Exception */
  $: isException = !!data.date;
  $: exception = isException && {
    reason: data.reason,
    date: formatter.formatDate(data.date),
    isOpen: data.open,
    hours: formatter.formatExceptionHours(data),
    statusText: formatter.statusText('CLOSED')
  };
</script>

{#each formattedHours as row, i}
  <div class="openinghours-row">
    <div class="days">{@html row.days}</div>
    {#if row.isOpen}
      <div class="hours">
        {#each row.hours as hours}
          <div class="hours__range">{@html hours}</div>
        {/each}
      </div>
    {:else}
      <div class="status">{row.statusText}</div>
    {/if}
  </div>
{/each}

{#if exception}
  <div class="reason">{exception.reason}</div>
  <div class="openinghours-row openinghours-row--exception">
    <div class="date">{exception.date}</div>
    {#if exception.isOpen}
      <div class="hours">{@html exception.hours}</div>
    {:else}
      <div class="status">{exception.statusText}</div>
    {/if}
  </div>
{/if}

<style>
  .openinghours-row {
    display: flex;
    flex-direction: row;
  }

  .days, .date {
    flex-shrink: 0;
    order: 1;
  }

  .hours, .status {
    flex-shrink: 0;
    order: 3;
  }

  .hours {
    font-feature-settings: "smcp" 1;
    text-align: right;
    text-transform: lowercase;
  }

  /* Helps visually group range rows to correct openinghours-row */
  .hours__range::after {
    position: absolute; /* Push into margin to align rows */
    content: ','
  }

  .hours__range:last-child::after {
    display: none;
  }

  .reason {
    width: 100%;
    margin-top: 16px;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.867; /* 24/18 * 1.4 */
    text-transform: uppercase;
  }

  .openinghours-row--exception {
    margin-top: 0;
  }

  .openinghours-row::after {
    content: '. . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . .';
    flex-grow: 1;
    height: 1.4em;
    margin: 0 8px;
    order: 2;
    overflow: hidden;
    opacity: .3;
  }
</style>
